export default "__VITE_ASSET__B45znHa1__"